module.exports = __webpack_public_path__ + "static/img/download.e859df91.png";